import React from 'react';

const Landing: React.FC = () => {
  return <></>;
};

export default Landing;
